import React, { Component } from 'react'
import { Link } from 'gatsby'

import Logo from './logo'

class Header extends Component {

  state = {
    active: false,
    menuActive: false,
    overlay: false,
    overlayAbout: false,
    scrolled: false,
  }

  constructor(props) {
    super(props)

    this._toggleOffCanvas = this._toggleOffCanvas.bind(this)
    this._hideOffCanvas = this._hideOffCanvas.bind(this)
  }

  componentDidMount() {
    if (typeof window === 'undefined') return
    window.addEventListener( 'scroll', () => {
      // normalize scroll position as percentage
      let scrolled = window.scrollY
      if (scrolled > 0) {
        !this.state.scrolled && this.setState({ scrolled: true })
      } else {
        this.state.scrolled && this.setState({ scrolled: false })
      }
    }, false)
  }

  _toggleOffCanvas() {
    if ( this.state.menuActive === true ) {
      this.setState({menuActive: false});
      document.querySelector('body').classList.remove('menu-open');
    } else {
      this.setState({menuActive: true});
      document.querySelector('body').classList.add('menu-open');
    }
  }

  _hideOffCanvas() {
    this.setState({menuActive: false});
    document.querySelector('body').classList.remove('menu-open');
  }

  render() {
    let { siteTitle, services, light } = this.props
    let { overlay, overlayAbout, scrolled } = this.state
    let clickProps = {
      onClick: this._hideOffCanvas,
      activeClassName: 'active',
    }
    const lightTheme = ['/process', '/process/', '/studio', '/studio/', '/learn/', '/learn', '/core', '/core/', '/services', '/services/', '/artist', '/artist/']
    if ( typeof window !== 'undefined' && lightTheme.find(uri => uri.indexOf(window.location.pathname) !== -1) ) {
      light = true;
    }

    let headerProps = {
      className: `header ${light && 'header--light'} ${scrolled && 'header--scrolled'}`
    }

    return (
      <>
        <header {...headerProps}>
          <div className="header__inner">
            <div className="header__logo">
              <Link to="/" title={siteTitle} onClick={this._hideOffCanvas}>
                <Logo color={light ? '#FFFFFF' : '#191919'} />
                <span className="header__logo-text">RAMUS</span>
              </Link>
            </div>
            <nav className="header__nav">
              <ul>
                <li>
                  <Link to="/works/designs" {...clickProps}>Projects</Link>
                </li>
                <li onMouseEnter={() => this.setState({ overlay: true })} onMouseLeave={() => this.setState({ overlay: false })}>
                  <Link to="/services" {...clickProps}>Services</Link>
                  <ul>
                    { services.edges && services.edges.map((el, i) => {
                      return (
                        <li key={i}><Link to={`/service/${el.node.slug}`} {...clickProps}>{el.node.title}</Link></li>
                      )
                    }) }
                  </ul>
                </li>
                <li onMouseEnter={() => this.setState({ overlayAbout: true })} onMouseLeave={() => this.setState({ overlayAbout: false })}>
                  <Link to="/studio" {...clickProps}>About</Link>
                  <ul>
                    <li><Link to="/artist" {...clickProps}>Artist</Link></li>
                    <li><Link to="/studio" {...clickProps}>Studio</Link></li>
                    <li><Link to="/process" {...clickProps}>Process</Link></li>
                    <li><Link to="/blog" {...clickProps}>Blog</Link></li>
                    <li><Link to="/social" {...clickProps}>Social</Link></li>
                  </ul>
                </li>
                <li>
                  <Link to="/learn" {...clickProps}>Learn</Link>
                </li>
                <li>
                  <Link to="/contact" {...clickProps}>Contact</Link>
                </li>
                <li><Link to="/">EN</Link> | <a href="https://ramus.cn">中文</a></li>
              </ul>
            </nav>
            <button className={ this.state.menuActive ? 'hamburger active' : 'hamburger' } onClick={this._toggleOffCanvas}>
              <span className="lines"></span>
            </button>
          </div>
        </header>
        <div className={`header__overlay ${overlay && 'header__overlay--active'} ${light && 'header--light'}`}></div>
        <div className={`header__overlay-about ${overlayAbout && 'header__overlay-about--active'} ${light && 'header--light'}`}></div>
        <div className={ `${this.state.menuActive ? 'off-canvas active' : 'off-canvas'} ${light && 'off-canvas--light'}` }>
          <div className="off-canvas__logo">
            <Link to="/" title={siteTitle} onClick={this._hideOffCanvas}>
              <Logo color={'#FFFFFF'} />
              <span className="off-canvas__logo-text">RAMUS</span>
            </Link>
          </div>
          <button className={ this.state.menuActive ? 'hamburger active' : 'hamburger' } onClick={this._toggleOffCanvas}>
            <span className="lines"></span>
          </button>
          <nav className="off-canvas__nav">
            <ul>
              <li className="col-1">
                <Link to="/works/designs" {...clickProps}>Works</Link>
                <ul>

                  <li><Link to="/works/designs" {...clickProps}>Projects</Link></li>
                </ul>
              </li>
              <li className="col-2">
                <Link to="/services" {...clickProps}>Services</Link>
                <ul>
                  { services.edges && services.edges.map((el, i) => {
                    return (
                      <li key={i}><Link to={`/service/${el.node.slug}`} {...clickProps}>{el.node.title}</Link></li>
                    )
                  }) }
                </ul>
              </li>
              <li className="col-3">
                <Link to="/studio" {...clickProps}>About</Link>
                <ul>
                  <li><Link to="/artist" {...clickProps}>Artist</Link></li>
                  <li><Link to="/studio" {...clickProps}>Studio</Link></li>
                  <li><Link to="/process" {...clickProps}>Process</Link></li>
                  <li><Link to="/blog" {...clickProps}>Blog</Link></li>
                  <li><Link to="/social" {...clickProps}>Social</Link></li>
                </ul>
              </li>
              <li className="col-4">
                <Link className="contact-menu" to="/learn" {...clickProps}>Learn</Link>
              </li>
              <li className="col-4">
                <Link className="contact-menu" to="/contact" {...clickProps}>Contact</Link>
              </li>
              <li className="col-5">
                <Link to="/">EN</Link> | <a href="https://cn.ramus.com.au">中文</a>
              </li>
            </ul>
          </nav>
          <nav className="off-canvas__social">
            <ul>
              <li>
                <a href="https://www.facebook.com/RamusIllumination/" target="_blank" rel="noopener noreferrer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="17" viewBox="0 0 9 17">
                    <path fill="#ffffff" fillRule="nonzero" d="M2.455 16.855V9.327H0V6.382h2.455V4.255c0-2.537 1.472-3.846 3.681-3.846C7.2.41 8.1.491 8.346.491v2.618H6.872c-1.146 0-1.391.573-1.391 1.391v1.882h2.782l-.41 2.945H5.4v7.528"/>
                  </svg>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/ramusstudio/" target="_blank" rel="noopener noreferrer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                    <path fill="#ffffff" fillRule="nonzero" d="M13.061 10c0-.901-.318-1.671-.956-2.309a3.146 3.146 0 0 0-2.309-.956c-.901 0-1.67.319-2.308.956A3.146 3.146 0 0 0 6.53 10c0 .901.32 1.671.957 2.309a3.146 3.146 0 0 0 2.308.956c.902 0 1.671-.319 2.309-.956A3.146 3.146 0 0 0 13.061 10zm1.76 0c0 1.395-.489 2.581-1.467 3.559-.978.977-2.164 1.466-3.558 1.467-1.395 0-2.58-.489-3.559-1.467C5.26 12.58 4.77 11.394 4.77 10c0-1.394.489-2.58 1.467-3.559.978-.978 2.164-1.467 3.559-1.467 1.394 0 2.58.49 3.558 1.467.978.978 1.467 2.164 1.467 3.559zM16.2 4.77c0 .324-.114.6-.344.83a1.13 1.13 0 0 1-.83.344c-.323 0-.599-.114-.829-.344a1.13 1.13 0 0 1-.344-.83c0-.323.115-.599.344-.829.23-.23.506-.344.83-.344.323 0 .6.115.829.344.23.23.344.506.344.83zM9.796 1.965l-.976-.006a68.653 68.653 0 0 0-1.346 0 46.84 46.84 0 0 0-1.23.038c-.515.022-.953.064-1.314.128a5.14 5.14 0 0 0-.912.236c-.425.17-.8.417-1.122.74-.323.323-.57.697-.74 1.122a5.14 5.14 0 0 0-.236.912c-.064.362-.106.8-.128 1.314a46.84 46.84 0 0 0-.038 1.23c-.005.307-.005.755 0 1.346L1.76 10l-.006.976c-.005.59-.005 1.04 0 1.345.004.307.017.717.038 1.231.022.514.064.952.128 1.314.064.361.142.665.236.912.17.425.416.8.74 1.122.323.323.697.57 1.122.74.247.093.55.172.912.236.361.064.8.106 1.314.128.514.021.924.034 1.23.038.306.004.755.004 1.346 0l.976-.006.975.006c.591.004 1.04.004 1.346 0a46.84 46.84 0 0 0 1.23-.038c.515-.022.953-.064 1.314-.128a5.14 5.14 0 0 0 .913-.236c.425-.17.799-.417 1.122-.74.323-.323.57-.697.74-1.122a5.14 5.14 0 0 0 .235-.912c.064-.362.107-.8.128-1.314.022-.514.035-.924.039-1.23.004-.307.004-.755 0-1.346L17.83 10l.007-.976c.004-.59.004-1.04 0-1.345a46.84 46.84 0 0 0-.039-1.231 10.127 10.127 0 0 0-.128-1.314 5.14 5.14 0 0 0-.235-.912c-.17-.425-.417-.8-.74-1.122a3.325 3.325 0 0 0-1.122-.74 5.14 5.14 0 0 0-.913-.236c-.361-.064-.799-.106-1.313-.128a46.84 46.84 0 0 0-1.23-.038 68.653 68.653 0 0 0-1.347 0l-.975.006zM19.592 10c0 1.947-.021 3.295-.063 4.044-.086 1.768-.613 3.137-1.582 4.107-.969.97-2.338 1.496-4.107 1.581-.748.043-2.096.064-4.044.064-1.947 0-3.295-.021-4.043-.064-1.769-.085-3.138-.612-4.107-1.581-.97-.97-1.497-2.338-1.582-4.107C.022 13.295.001 11.948.001 10c0-1.948.02-3.295.063-4.044C.15 4.188.677 2.82 1.646 1.85 2.615.88 3.984.353 5.753.268 6.5.225 7.849.204 9.796.204c1.948 0 3.296.021 4.044.064 1.769.085 3.138.612 4.107 1.581.97.97 1.497 2.338 1.582 4.107.042.749.063 2.096.063 4.044z"/>
                  </svg>
                </a>
              </li>
              <li>
                <a href="https://www.youtube.com/channel/UCK8bcYo9Db1sX5VIwZHtLNg" target="_blank" rel="noopener noreferrer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15">
                    <path fill="#ffffff" fillRule="nonzero" d="M7.935 9.955v-5.81l5.403 2.915-5.403 2.895zM19.8 3.138s-.196-1.425-.795-2.053c-.76-.824-1.613-.828-2.004-.876C14.202 0 10.004 0 10.004 0h-.008S5.797 0 2.999.21C2.607.256 1.756.26.994 1.084.395 1.713.2 3.138.2 3.138S0 4.81 0 6.485v1.569C0 9.728.2 11.4.2 11.4s.195 1.425.794 2.052c.762.824 1.761.798 2.206.884 1.6.16 6.8.208 6.8.208s4.203-.006 7.001-.215c.39-.049 1.243-.053 2.004-.877.6-.627.795-2.052.795-2.052s.2-1.673.2-3.347v-1.57c0-1.673-.2-3.346-.2-3.346z"/>
                  </svg>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </>
    )
  }
}

export default Header
